import { toast } from 'react-hot-toast';

export const Notification = (title: string, body?: string) => {
  return toast(
    (t) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '10px',
          minWidth: '260px',
        }}
      >
        <div style={{ flex: 1 }}>
          <div
            style={{ fontWeight: 600, fontSize: '14px', marginBottom: '4px' }}
          >
            {title}
          </div>
          {body && (
            <div style={{ fontSize: '13px', opacity: 0.85 }}>{body}</div>
          )}
        </div>

        <button
          onClick={() => toast.dismiss(t.id)}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            opacity: 0.7,
            padding: 0,
          }}
        >
          ✕
        </button>
      </div>
    ),
    {
      position: 'top-right',
      duration: 6000,
      icon: '🔔',
    },
  );
};
